<template>
    <div :class="[containerClasses, 'relative w-full xxs:px-4 lg:px-3 xxs:py-4 border-b border-px border-interactive-9 flex xxs:flex-col lg:flex-row hover:bg-background-3']">
        <div v-if="layout === 'inbox'" class="flex flex-row items-center xxs:mr-0 lg:mr-4">
            <Checkbox :model-value="isOptionSelected" @update:model-value="$emit('update:model-value', item.uid)"/>
            <div v-show="'read_at' in item && activeFolder !== 'bin'"
                 @click="$emit('toggleFavorite')" class="w-4 h-4 mr-2 cursor-pointer">
                <img v-if="!item.favorite" src="@/assets/icons/star_empty.svg" alt="Mark as favorite"/>
                <img v-else src="@/assets/icons/star_filled.svg" alt="favorite"/>
            </div>
            <div class="xxs:flex lg:hidden text-right flex-row items-center justify-end xxs:mt-2 text-body-6 text-default-1 flex-1">
                <img v-if="emailData.files.length" src="@/assets/icons/attachment.svg" alt="attachment" class="w-4 h-4 mr-2"/>
                <p v-if="emailData.sent_at ===  null && emailData.scheduled_at !== null" class="mr-1">Scheduled</p>
                <p :class="!isRead && item.sent_at !== null && 'font-medium'">{{formattedDate}}</p>
            </div>
        </div>
        <div
            @click="$emit('clicked')"
            :class="[!isRead && item.sent_at !== null && 'font-medium', 'flex flex-col justify-between items-start text-default-1 text-body-6 cursor-pointer flex-1 pr-6']"
        >
            <p :class="[emailSubjectClasses, 'overflow-hidden overflow-ellipsis multi-line-ellipsis clamp-1-line max-h-[60px] xxs:mr-0 md:mr-4']">
                {{emailData.subject}}
                <span class="font-normal text-body-7" v-if="Object.hasOwn(item, 'draft') && activeFolder === 'bin'">
                (Sent)
                </span>
            </p>
            <p :class="[emailBodyClasses, 'overflow-hidden overflow-ellipsis multi-line-ellipsis clamp-1-line max-h-[60px] text-body-6 text-interactive-6 font-light']">
                {{noHTMLBody}}
            </p>
        </div>
        <div class="xxs:hidden lg:flex text-right flex-row items-center justify-end xxs:mt-2 lg:mt-0 text-default-1 text-body-6">
            <img v-if="emailData.files.length" src="@/assets/icons/attachment.svg" alt="attachment" class="w-4 h-4 mr-2"/>
            <p :class="!isRead && item.sent_at !== null && 'font-medium'">{{formattedDate}}</p>
        </div>
    </div>
</template>
<script setup>
import {computed, defineProps} from "vue";
import Checkbox from "@/components/core/Checkbox.vue";
import moment from "moment";

const props = defineProps({
    item: {
        type: Object,
        default: () => {},
        required: true,
    },
    selectedItems: {
        type: Array,
        default: () => [],
    },
    layout: {
        type: String,
        default: 'inbox',
        required: true
    },
    size: {
        type: String,
        default: 'small',
        required: false
    },
    activeFolder: {
        type: String,
        default: 'inbox',
    },
});

const emit = defineEmits(['clicked', 'deleted', 'update:model-value', 'toggleFavorite']);

const isRead = computed(() => {
    return (typeof props.item.read_at === 'string');
});

const formattedDate = computed(() => {
    if (props.item.draft)
        return moment(props.item.created_at).format('MM/DD/YY');
    else if ('sent_at' in props.item && props.item.sent_at !== null)
        return moment(props.item.sent_at).format('MM/DD/YY');
    else if ('scheduled_at' in props.item && props.item.scheduled_at !== null)
        return moment(props.item.scheduled_at).format('MM/DD/YY for HH:mm');

    return moment(props.item.created_at).format('MM/DD/YY');
});

const isOptionSelected = computed(() => {
    return props.selectedItems.filter(selected => selected === props.item.uid).length > 0
})

const emailData = computed(() => {
    return props.item.email ? props.item.email : props.item
})

const noHTMLBody = computed(() => {
    if (!emailData.value?.body) return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(emailData.value.body, 'text/html');

    const bodyElement = doc.querySelector('body');

    if (bodyElement) {
        return bodyElement.textContent || bodyElement.innerText || '';
    }

    return doc.body ? doc.body.textContent || doc.body.innerText || '' : '';
});

const containerClasses = computed(() => {
    return {
        'lg:py-4': props.size === 'small',
        'lg:py-6': props.size !== 'small',
    }
});

const emailSubjectClasses = computed(() => {
    return {
        'w-full' : true,
        'xxs:mt-4 lg:mt-0': props.layout === 'inbox',
    }
})

const emailBodyClasses = computed(() => {
    return {
        'w-full' : true,
        'xxs:mt-2 lg:mt-0': props.layout === 'inbox',
    }
})
</script>